import React from 'react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: '📚',
      title: 'Expert Faculty',
      description: 'Our experienced educators bring years of teaching excellence and subject mastery to ensure every student receives top-notch guidance and mentorship.'
    },
    {
      icon: '🎯',
      title: 'Proven Track Record',
      description: 'With 10 years of excellence since 2015, we\'ve successfully guided over 1000+ students to achieve outstanding academic results and reach their full potential.'
    },
    {
      icon: '🌐',
      title: 'All Boards Covered',
      description: 'Comprehensive coaching for CBSE, Matric, IGCSE, ICSE, and IB syllabi with specialized curriculum and teaching methods for each board.'
    },
    {
      icon: '💡',
      title: 'Personalized Attention',
      description: 'Small batch sizes ensure individual focus on each student\'s learning needs, strengths, and areas requiring improvement.'
    },
    {
      icon: '🏆',
      title: 'Result-Oriented',
      description: 'Our methodical approach combines conceptual clarity with regular assessments and practice to ensure exam readiness and academic excellence.'
    },
    {
      icon: '🔬',
      title: 'Modern Learning',
      description: 'Integration of technology with traditional teaching methods, offering digital resources and interactive learning experiences.'
    }
  ];

  return (
    <section id="about">
      <div className="section-header">
        <h2 className="section-title">Why Choose Tesla's Academy?</h2>
        <p className="section-subtitle">
          A proven track record of making students exam-ready and future-proof
        </p>
      </div>
      <div className="about-content">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <div className="feature-icon">{feature.icon}</div>
            <h3 className="feature-title">{feature.title}</h3>
            <p className="feature-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default About;
